<template lang="html">
  <div class="course-type-bar">
    <div class="course-type-bar-main">
      <div class="course-type-bar-l">
        <img :src="typeImg" alt="">{{courseTypeName}}
        <!-- ({{learningCount}}已学习) -->
      </div>
      <div class="course-type-bar-r">
        <img src="../assets/images/right-icon.png" alt="">{{!courseDeadline || courseDeadline == '' || courseDeadline == null ? '永久有效' : `${courseDeadline}天有效期`}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseTypeBar",
  props: ["courseType", "learningCount", "courseDeadline"],
  computed: {
    courseTypeName() {
      switch (this.courseType) {
        case 1:
          return "视频课";
        case 2:
          return "音频课";
        case 3:
          return "视频+音频课";
        case 4:
          return "直播课";
        case 5:
          return "视频+直播课";
        case 6:
          return "音频+直播课";
        case 8:
          return "AI课";
        default:
          return "视频+音频+直播课";
      }
    },
    typeImg() {
      if (this.courseType === 2) {
        return require("../assets/images/audio-icon.png");
      } else {
        return require("../assets/images/video-icon.png");
      }
    },
  },
};
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.course-type-bar {
  padding: 0 rem(27);
  font-size: rem(24);
  color: #333333;
  
  &-main {
    border-bottom: 1px solid #e4e4e4;
    height: rem(80);
    line-height: rem(80);
    &::after {
      content: "";
      display: block;
      clear: both;
    }
  }
  img {
    width: rem(24);
    margin-right: rem(5);
    vertical-align: middle;
  }
  &-l {
    float: left;
  }
  &-r {
    float: right;
  }
}
</style>
